import {Popup} from '@components/common/popup/popup'
import {useSyncEvent} from '@containers/hooks'
import {useCompanyUpdateEffect} from '@containers/update-hooks'
import {globals} from '@extensions/globals-base'
import {observer} from 'mobx-react-lite'
import React, {useEffect} from 'react'
import {Lang} from 'yougile-lang'
import {WorkflowEditor} from './workflow-editor'
import {WorkflowList} from './workflow-list'
import {popupStore} from './workflow-popup-store'

export const WorkflowPopup = observer(() => {
  useWorkflowsUpdateEffect()
  const close = () => popupStore.close()

  if (!popupStore.state.boardId) {
    return null
  }

  return (
    <Popup
      width={640}
      title={`${Lang.msg.workflow.workflowsInBoard} “${popupStore.board.title}”`}
      close={close}
    >
      {popupStore.state.editedWorkflow ? <WorkflowEditor /> : <WorkflowList />}
    </Popup>
  )
})

const useWorkflowsUpdateEffect = () => {
  useSyncEvent('current', {filter: () => globals.getCompanyId()}, () => {
    popupStore.updateWorkflows()
  })
  useCompanyUpdateEffect(() => popupStore.updateWorkflows())
  useEffect(() => {
    popupStore.updateWorkflows()
  }, [])
}
